import { Color } from '@diritto/common/style/color';

export const ListIcon = ({ color = Color.Black }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 13H4V11H2V13ZM2 20H4V18H2V20ZM2 6H4V4H2V6ZM6 13H22V11H6V13ZM6 20H22V18H6V20ZM6 4V6H22V4H6Z"
      fill={color}
    />
  </svg>
);
